import React from "react";

type Props = {
  block: number | number[];
  colNum: number;
  rowNum: number;
  reachedHere: number[] | undefined;
};

function Block({ block, rowNum, colNum, reachedHere }: Props) {
  let curStyle = {};
  if (reachedHere && rowNum <= reachedHere[0]) {
    curStyle = { background: "rgb(0, 255, 179)", color: "rgba(0,0,0,0.6)" };
  }
  if (reachedHere && rowNum == reachedHere[0] && colNum == reachedHere[1] - 1) {
    curStyle = { background: "rgb(255, 0, 149)", color: "rgba(0,0,0,0.6)" };
  }
  if (reachedHere && rowNum == reachedHere[0] && colNum > reachedHere[1] - 1) {
    curStyle = { background: "transparent", color: "white" };
  }
  if (reachedHere && rowNum > reachedHere[0]) {
    curStyle = { background: "transparent", color: "white" };
  }

  return (
    <div
      className="SudokuBlock"
      key={rowNum + "," + colNum}
      style={{
        ...curStyle,
        fontFamily: "var(--font-sudoku-nums)",
      }}
    >
      {block == 0 ? "" : block}
    </div>
  );
}

export default Block;
